import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { OptionsDisplay, CommunityPageType } from './options';

const CommunityOptions = ({ images, lang, optionLinks }) => (
   <OptionsDisplay
      images={images}
      lang={lang}
      links={optionLinks}
      page={CommunityPageType.PARTICIPATION}
   />
);

initializeChakraComponent('CommunityOptions', CommunityOptions);
